
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index854hq0DU0W6hAW0yFkUYkOY9aVXyrnK4JiXZ6HJAn_0Meta } from "/usr/src/nuxt-app/pages/index.vue?macro=true";
import { default as datatfZ5qjkOdWzEN1DAeQmMY6_45VkBBIn5k6TefgtUrTNKgMeta } from "/usr/src/nuxt-app/pages/terms/data.ts?macro=true";
import { default as indexh7rph6b9YMtbXkspAQ_pT0YHHE_U1je7_45QzcC6SNNPsMeta } from "/usr/src/nuxt-app/pages/vin/index.vue?macro=true";
import { default as indexSD_FDT9QmOVGF2QfyqAwQYjgqp8G_M1he_45pdxU7b8IkMeta } from "/usr/src/nuxt-app/pages/cart/index.vue?macro=true";
import { default as indexr41v0GLj7Vgi323BO4Hnhza546rWhTODROzJ4_45s7gNkMeta } from "/usr/src/nuxt-app/pages/news/index.vue?macro=true";
import { default as _91slug_93H3XfG2NRc3QSRRdrsxyVY6CozVbGouIDf_qiyY5x_45awMeta } from "/usr/src/nuxt-app/pages/vin/[slug].vue?macro=true";
import { default as detailAWBhXOwqwka3iCT0nsCrX8dYYdv2FG5emgkllMJsonUMeta } from "/usr/src/nuxt-app/pages/vin/detail.vue?macro=true";
import { default as indexNHtLpNci1vEhxr5s0p5Bg3LOP_DaH5LBTkPovrsAl0gMeta } from "/usr/src/nuxt-app/pages/about/index.vue?macro=true";
import { default as _91id_93jBYHejnlc1ftrNJuaHtrDFpjEh5EDaW5o1vsG9C0FSoMeta } from "/usr/src/nuxt-app/pages/brands/[id].vue?macro=true";
import { default as _91slug_93oqivvInLZgGsfGxR5B8CM7Jt1OvlqgQnBdD74l_45eDcMMeta } from "/usr/src/nuxt-app/pages/news/[slug].vue?macro=true";
import { default as indexM8Pm7Nkazfqz8f5jf8pkDX0LkIgqo28HgeDaUa8sPTQMeta } from "/usr/src/nuxt-app/pages/order/index.vue?macro=true";
import { default as datapmutDOPwZGnJMRX_451rgCXE5xIdTxbVrLgknFD_9FWc0Meta } from "/usr/src/nuxt-app/pages/privacy/data.ts?macro=true";
import { default as _91id_93aMRZ463_45Kk7nzcVwKxbZ2s15xyDYreU41DPLCvvoqgUMeta } from "/usr/src/nuxt-app/pages/search/[id].vue?macro=true";
import { default as indexSxt6cAHF9c5UuX_an91RaoGRc3EENs1WaSjw9SS5r_45YMeta } from "/usr/src/nuxt-app/pages/terms/index.vue?macro=true";
import { default as index7ukkhFJjmqkpQbfnHfNPpnyErjtg2IMJPPKuWnB1sMUMeta } from "/usr/src/nuxt-app/pages/brands/index.vue?macro=true";
import { default as indexnVtTiYFv_rx5bS7sRYAUo8UDn6f5_GleXnsSfNO9n40Meta } from "/usr/src/nuxt-app/pages/account/index.vue?macro=true";
import { default as indexhg6vm3mqUD02VieFVLEEanTuwX6dmeyc_45m_RdEUKYb8Meta } from "/usr/src/nuxt-app/pages/catalog/index.vue?macro=true";
import { default as index5fqlSnGceoj9khy74uTrThIYXoYAVvrax_45GnLk8ZPpUMeta } from "/usr/src/nuxt-app/pages/privacy/index.vue?macro=true";
import { default as index6jarQWVyVmqwY5x6nApru_45Y2eeaavf55lSF4dlkFSV4Meta } from "/usr/src/nuxt-app/pages/delivery/index.vue?macro=true";
import { default as indexpFOkmLrLX7DcNfJf9SPa8CfD8p_CI5WUtjb8niK3XZsMeta } from "/usr/src/nuxt-app/pages/products/index.vue?macro=true";
import { default as finance7m3_LEfxu1NSiky4c76XMsFER_45nAyH6AXyDyZG7S_NwMeta } from "/usr/src/nuxt-app/pages/account/finance.vue?macro=true";
import { default as _91slug_93IWNck9w7pQ3_LnXAzy_45eCvOkxdFIdyvxRgtry5k5lxMMeta } from "/usr/src/nuxt-app/pages/contacts/[slug].vue?macro=true";
import { default as managerssFr9REJWTW12PIahTmbdIJrStCJphUGPK_zU0hh5hoMMeta } from "/usr/src/nuxt-app/pages/account/managers.vue?macro=true";
import { default as personalghz56LgG5Zp7VV2bgLnkgOo6qLcOvXEMknqSFAoOcK8Meta } from "/usr/src/nuxt-app/pages/account/personal.vue?macro=true";
import { default as indexjqobjM03fELBAyq73_45azPW40YPhY8oi9_wNzlwH3W3QMeta } from "/usr/src/nuxt-app/pages/promotions/index.vue?macro=true";
import { default as indexuOq61_18KbRlwIlYHr02rtDK7aDl24ENeFRX9eM07W0Meta } from "/usr/src/nuxt-app/pages/about-brand/index.vue?macro=true";
import { default as addressesH6BwyUXaRiHqt0PYCclAe3FOSXAcKEcHE2hlyc2BA60Meta } from "/usr/src/nuxt-app/pages/account/addresses.vue?macro=true";
import { default as companiesLA0BWH0x6O84PGx7mCmRK8AlzdlLWey4MDs3WWuqQWwMeta } from "/usr/src/nuxt-app/pages/account/companies.vue?macro=true";
import { default as _91_46_46_46slug_93Ppq0JOKYZ5k41NVG3dQHJI6rni8HBWsYlb3k9GVmOjAMeta } from "/usr/src/nuxt-app/pages/catalog/[...slug].vue?macro=true";
import { default as _91slug_93Svsrv7EArPZusV_pJaNi16YM9Upvf2qfl87NXz_vwTkMeta } from "/usr/src/nuxt-app/pages/promotions/[slug].vue?macro=true";
import { default as userTxamBGnLOX_N4nDdrzJImEzIegaAYEbFaD1XYb_FBmcMeta } from "/usr/src/nuxt-app/pages/registration/user.vue?macro=true";
import { default as _91id_93Jx_45XcST6jk0v_7DHrhl9kxcnZx1gcC7bx_45ZMAwCT61sMeta } from "/usr/src/nuxt-app/pages/search/query/[id].vue?macro=true";
import { default as modifications7KGN4LvHbFh0MtRWXnrtT51mqirGcIeMaE6x642DtpUMeta } from "/usr/src/nuxt-app/pages/vin/modifications.vue?macro=true";
import { default as order_45successsiG2zLArFnQi7_rfluldPdr5GCTOyaQPjnAf70O2b7AMeta } from "/usr/src/nuxt-app/pages/cart/order-success.vue?macro=true";
import { default as _91_46_46_46slug_93R9CYnzQZosJMmWyuL04jUbiwDPSxRoPaL7Xgi_UMM_IMeta } from "/usr/src/nuxt-app/pages/products/[...slug].vue?macro=true";
import { default as indexUpXmEU4ILo7Pnq81yJfYTdvDxsdCaWilJO_45vvVkga_8Meta } from "/usr/src/nuxt-app/pages/registration/index.vue?macro=true";
import { default as _91id_93kgUCONPw6DblyWMe61DqsiCunCxOxOGq_45ZdJW4vD7OQMeta } from "/usr/src/nuxt-app/pages/account/orders/[id].vue?macro=true";
import { default as _91id_932frklm3F7G0OeFCRezS0Z4K5sqqySfg9UGapLgkYmCUMeta } from "/usr/src/nuxt-app/pages/search/product/[id].vue?macro=true";
import { default as catalog_45details_45fLuvU0hlEHIbEcYkrJH_7hu_jfnZpB8rOy3xJhZG1cMeta } from "/usr/src/nuxt-app/pages/vin/catalog-details.vue?macro=true";
import { default as indexLrDfJs3gBqXfEHwQqCc3r3wJSMi4qKNXq_iGpYYzEecMeta } from "/usr/src/nuxt-app/pages/account/orders/index.vue?macro=true";
import { default as company4muw6sv_45E1IRcDOSTgKD4eFcGLRa8c_nWknpSWJk_LoMeta } from "/usr/src/nuxt-app/pages/registration/company.vue?macro=true";
import { default as successIzRvspxenNKAQiU9Ese0TLCk7jHcXfy4N8cf3yz2wj0Meta } from "/usr/src/nuxt-app/pages/registration/success.vue?macro=true";
import { default as _91id_93tLUdGx9Tm_3ulrUvqCRw4qc3qEX9S7nzzhzGDUXRHVwMeta } from "/usr/src/nuxt-app/pages/search/[article]/[id].vue?macro=true";
import { default as search_45historymx6eDAYpFeGFV8jqcwRPK2Muran_454wjM1ToLYMd_45rNwMeta } from "/usr/src/nuxt-app/pages/account/search-history.vue?macro=true";
import { default as _91token_93TfmKJ4mbCwMLDTaHhqooQmpyEKRNE3rCkShGHnhqrr4Meta } from "/usr/src/nuxt-app/pages/forgot-password/[token].vue?macro=true";
import { default as indexee8UHt9QNGqySGgXFbFG5EFnxsHtdGmfpKnTiRZPgOQMeta } from "/usr/src/nuxt-app/pages/download-positions/index.vue?macro=true";
import { default as sorting_45warehousesG_lkger7MeldJS4sMalQERg0MvaGMWE_YL3A21XWwH4Meta } from "/usr/src/nuxt-app/pages/account/sorting-warehouses.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index854hq0DU0W6hAW0yFkUYkOY9aVXyrnK4JiXZ6HJAn_0Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/index.vue")
  },
  {
    name: "terms-data",
    path: "/terms/data",
    component: () => import("/usr/src/nuxt-app/pages/terms/data.ts")
  },
  {
    name: "vin",
    path: "/vin",
    meta: indexh7rph6b9YMtbXkspAQ_pT0YHHE_U1je7_45QzcC6SNNPsMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/vin/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/usr/src/nuxt-app/pages/cart/index.vue")
  },
  {
    name: "news",
    path: "/news",
    meta: indexr41v0GLj7Vgi323BO4Hnhza546rWhTODROzJ4_45s7gNkMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/news/index.vue")
  },
  {
    name: "vin-slug",
    path: "/vin/:slug()",
    meta: _91slug_93H3XfG2NRc3QSRRdrsxyVY6CozVbGouIDf_qiyY5x_45awMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/vin/[slug].vue")
  },
  {
    name: "vin-detail",
    path: "/vin/detail",
    meta: detailAWBhXOwqwka3iCT0nsCrX8dYYdv2FG5emgkllMJsonUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/vin/detail.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: indexNHtLpNci1vEhxr5s0p5Bg3LOP_DaH5LBTkPovrsAl0gMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/about/index.vue")
  },
  {
    name: "brands-id",
    path: "/brands/:id()",
    meta: _91id_93jBYHejnlc1ftrNJuaHtrDFpjEh5EDaW5o1vsG9C0FSoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/brands/[id].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    meta: _91slug_93oqivvInLZgGsfGxR5B8CM7Jt1OvlqgQnBdD74l_45eDcMMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "order",
    path: "/order",
    meta: indexM8Pm7Nkazfqz8f5jf8pkDX0LkIgqo28HgeDaUa8sPTQMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/order/index.vue")
  },
  {
    name: "privacy-data",
    path: "/privacy/data",
    component: () => import("/usr/src/nuxt-app/pages/privacy/data.ts")
  },
  {
    name: "search-id",
    path: "/search/:id()",
    meta: _91id_93aMRZ463_45Kk7nzcVwKxbZ2s15xyDYreU41DPLCvvoqgUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/search/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexSxt6cAHF9c5UuX_an91RaoGRc3EENs1WaSjw9SS5r_45YMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/terms/index.vue")
  },
  {
    name: "brands",
    path: "/brands",
    meta: index7ukkhFJjmqkpQbfnHfNPpnyErjtg2IMJPPKuWnB1sMUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/brands/index.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexnVtTiYFv_rx5bS7sRYAUo8UDn6f5_GleXnsSfNO9n40Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/index.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    meta: indexhg6vm3mqUD02VieFVLEEanTuwX6dmeyc_45m_RdEUKYb8Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/catalog/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: index5fqlSnGceoj9khy74uTrThIYXoYAVvrax_45GnLk8ZPpUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/privacy/index.vue")
  },
  {
    name: "delivery",
    path: "/delivery",
    meta: index6jarQWVyVmqwY5x6nApru_45Y2eeaavf55lSF4dlkFSV4Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/delivery/index.vue")
  },
  {
    name: "products",
    path: "/products",
    meta: indexpFOkmLrLX7DcNfJf9SPa8CfD8p_CI5WUtjb8niK3XZsMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/products/index.vue")
  },
  {
    name: "account-finance",
    path: "/account/finance",
    meta: finance7m3_LEfxu1NSiky4c76XMsFER_45nAyH6AXyDyZG7S_NwMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/finance.vue")
  },
  {
    name: "contacts-slug",
    path: "/contacts/:slug()",
    meta: _91slug_93IWNck9w7pQ3_LnXAzy_45eCvOkxdFIdyvxRgtry5k5lxMMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/contacts/[slug].vue")
  },
  {
    name: "account-managers",
    path: "/account/managers",
    meta: managerssFr9REJWTW12PIahTmbdIJrStCJphUGPK_zU0hh5hoMMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/managers.vue")
  },
  {
    name: "account-personal",
    path: "/account/personal",
    meta: personalghz56LgG5Zp7VV2bgLnkgOo6qLcOvXEMknqSFAoOcK8Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/personal.vue")
  },
  {
    name: "promotions",
    path: "/promotions",
    meta: indexjqobjM03fELBAyq73_45azPW40YPhY8oi9_wNzlwH3W3QMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/promotions/index.vue")
  },
  {
    name: "about-brand",
    path: "/about-brand",
    meta: indexuOq61_18KbRlwIlYHr02rtDK7aDl24ENeFRX9eM07W0Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/about-brand/index.vue")
  },
  {
    name: "account-addresses",
    path: "/account/addresses",
    meta: addressesH6BwyUXaRiHqt0PYCclAe3FOSXAcKEcHE2hlyc2BA60Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/addresses.vue")
  },
  {
    name: "account-companies",
    path: "/account/companies",
    meta: companiesLA0BWH0x6O84PGx7mCmRK8AlzdlLWey4MDs3WWuqQWwMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/companies.vue")
  },
  {
    name: "catalog-slug",
    path: "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93Ppq0JOKYZ5k41NVG3dQHJI6rni8HBWsYlb3k9GVmOjAMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/catalog/[...slug].vue")
  },
  {
    name: "promotions-slug",
    path: "/promotions/:slug()",
    meta: _91slug_93Svsrv7EArPZusV_pJaNi16YM9Upvf2qfl87NXz_vwTkMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/promotions/[slug].vue")
  },
  {
    name: "registration-user",
    path: "/registration/user",
    meta: userTxamBGnLOX_N4nDdrzJImEzIegaAYEbFaD1XYb_FBmcMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/registration/user.vue")
  },
  {
    name: "search-query-id",
    path: "/search/query/:id()",
    meta: _91id_93Jx_45XcST6jk0v_7DHrhl9kxcnZx1gcC7bx_45ZMAwCT61sMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/search/query/[id].vue")
  },
  {
    name: "vin-modifications",
    path: "/vin/modifications",
    meta: modifications7KGN4LvHbFh0MtRWXnrtT51mqirGcIeMaE6x642DtpUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/vin/modifications.vue")
  },
  {
    name: "cart-order-success",
    path: "/cart/order-success",
    meta: order_45successsiG2zLArFnQi7_rfluldPdr5GCTOyaQPjnAf70O2b7AMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/cart/order-success.vue")
  },
  {
    name: "products-slug",
    path: "/products/:slug(.*)*",
    meta: _91_46_46_46slug_93R9CYnzQZosJMmWyuL04jUbiwDPSxRoPaL7Xgi_UMM_IMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/products/[...slug].vue")
  },
  {
    name: "registration",
    path: "/registration",
    meta: indexUpXmEU4ILo7Pnq81yJfYTdvDxsdCaWilJO_45vvVkga_8Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/registration/index.vue")
  },
  {
    name: "account-orders-id",
    path: "/account/orders/:id()",
    meta: _91id_93kgUCONPw6DblyWMe61DqsiCunCxOxOGq_45ZdJW4vD7OQMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/orders/[id].vue")
  },
  {
    name: "search-product-id",
    path: "/search/product/:id()",
    meta: _91id_932frklm3F7G0OeFCRezS0Z4K5sqqySfg9UGapLgkYmCUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/search/product/[id].vue")
  },
  {
    name: "vin-catalog-details",
    path: "/vin/catalog-details",
    meta: catalog_45details_45fLuvU0hlEHIbEcYkrJH_7hu_jfnZpB8rOy3xJhZG1cMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/vin/catalog-details.vue")
  },
  {
    name: "account-orders",
    path: "/account/orders",
    meta: indexLrDfJs3gBqXfEHwQqCc3r3wJSMi4qKNXq_iGpYYzEecMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/orders/index.vue")
  },
  {
    name: "registration-company",
    path: "/registration/company",
    meta: company4muw6sv_45E1IRcDOSTgKD4eFcGLRa8c_nWknpSWJk_LoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/registration/company.vue")
  },
  {
    name: "registration-success",
    path: "/registration/success",
    meta: successIzRvspxenNKAQiU9Ese0TLCk7jHcXfy4N8cf3yz2wj0Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/registration/success.vue")
  },
  {
    name: "search-article-id",
    path: "/search/:article()/:id()",
    meta: _91id_93tLUdGx9Tm_3ulrUvqCRw4qc3qEX9S7nzzhzGDUXRHVwMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/search/[article]/[id].vue")
  },
  {
    name: "account-search-history",
    path: "/account/search-history",
    meta: search_45historymx6eDAYpFeGFV8jqcwRPK2Muran_454wjM1ToLYMd_45rNwMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/search-history.vue")
  },
  {
    name: "forgot-password-token",
    path: "/forgot-password/:token()",
    meta: _91token_93TfmKJ4mbCwMLDTaHhqooQmpyEKRNE3rCkShGHnhqrr4Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/forgot-password/[token].vue")
  },
  {
    name: "download-positions",
    path: "/download-positions",
    component: () => import("/usr/src/nuxt-app/pages/download-positions/index.vue")
  },
  {
    name: "account-sorting-warehouses",
    path: "/account/sorting-warehouses",
    meta: sorting_45warehousesG_lkger7MeldJS4sMalQERg0MvaGMWE_YL3A21XWwH4Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/sorting-warehouses.vue")
  }
]